import { render } from "./UserInCompanyChart.vue?vue&type=template&id=008af64e&ts=true"
import script from "./UserInCompanyChart.vue?vue&type=script&lang=ts"
export * from "./UserInCompanyChart.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__